import React, { useEffect, useState, useRef } from "react";
import { Row, Col, } from "react-bootstrap";
// import PriceTrendChart from "../../charts/priceTrend/index";
import PriceTrendChartRechart from "pages/customPricing/charts/PriceTrendChartRecharts";
import PriceTrendMinMaxChartRechart from "pages/customPricing/charts/PriceTrendMinMaxChartRecharts";
import PriceTrendMinMaxChart from "../..//charts/priceTrend/minMax"
import ForwardCurveChart from "../../charts/forwardCurve/index"
// redux
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from "providers/CustomAuthProvider";
import { fetchPricingDetail } from "pages/customPricing/store/actions";
import ConfirmationModal from "@enerex/unified-ui-react/ConfirmationModal";
import Div from "components/Div";
import loader from "../../../../assets/images/datahub-loader.svg"

// Custom Tooltip Component
const MultipleValuesTooltip = ({ values }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const spanRef = useRef(null);

  const handleMouseEnter = (e) => {
    if (spanRef.current) {
      const rect = spanRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + 5,
        left: rect.left
      });
    }
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  if (!values || values.length <= 1) {
    return values && values.length === 1 ? values[0] : '-';
  }

  return (
    <>
      <span
        ref={spanRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ cursor: 'help', textDecoration: 'underline', textDecorationStyle: 'dotted', position: 'relative' }}
      >
        Multiple
      </span>
      {showTooltip && (
        <div
          style={{
            position: 'fixed',
            top: `${position.top}px`,
            left: `${position.left}px`,
            backgroundColor: '#333',
            color: '#fff',
            padding: '8px 12px',
            borderRadius: '4px',
            fontSize: '12px',
            zIndex: 10000,
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            maxWidth: '300px',
            whiteSpace: 'normal',
            textAlign: 'left'
          }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={handleMouseLeave}
        >
          <ul style={{ margin: 0, paddingLeft: '20px', listStyleType: 'disc', textAlign: 'left' }}>
            {values.map((value, index) => (
              <li key={index} style={{ marginBottom: '2px', textAlign: 'left' }}>{value}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

const ChartSection = () => {

  const [priceTrendData, setPriceTrendData] = useState([]);
  const dispatch = useDispatch();
  const { clientId, isSystemAdmin, accessToken, isPremium } = useAuth();
  const pricingTrendData = useSelector((state) => state.customPricing.chartsData?.priceTrend);
  const pricingTrendMinMaxData = useSelector((state) => state.customPricing.chartsData?.priceTrendMinMax);
  const selectedClientIdentifier = useSelector((state) => state.customPricing.selectedClientIdentifier);
  const pricingDetail = useSelector((state) => state.customPricing.pricingDetail);
  const pricingDetailLoading = useSelector((state) => state.customPricing.pricingDetailLoading);
  const commodity = useSelector((state) => state.customPricing.commodity);
  const selectedMarket = useSelector((state) => state.customPricing.selectedMarket);
  const selectedState = useSelector((state) => state.customPricing.selectedState);

  const [showDetailModal, setShowDetailModal] = useState(false);
  const shouldBlurCharts = isPremium === false;

  // Determine if market is gas (commodity 2)
  const isGasMarket = (() => {
    if (commodity === 2) return true;
    if (commodity === 1) return false;
    // Fallback to selectedMarket commodity
    const marketCommodity = selectedMarket?.commodity;
    if (marketCommodity === 'NatGas' || marketCommodity === 'Gas' || marketCommodity === 'Nat Gas' || marketCommodity === 2 || marketCommodity === '2') {
      return true;
    }
    return false;
  })();

  const annualUsageUnit = isGasMarket ? '(therm)' : '(kWh)';

  // Determine column label for Rate Class/Load Profile
  const rateClassLabel = (selectedMarket?.name === 'ERCOT' && selectedState?.name === 'Texas')
    ? 'Load Profile'
    : 'Rate Class';

  const handlePointClick = (bookedDate, supplierId) => {
    if (!accessToken || !bookedDate || !supplierId) return;

    dispatch(
      fetchPricingDetail({
        clientId,
        selectedClientIdentifier,
        userToken: accessToken,
        IsNotAnonymized: false,
        isSystemAdmin,
        bookedDate,
        supplierId,
      })
    );
    setShowDetailModal(true);
  };

  //   useEffect(() => {
  //     // const response = generateTrendPriceData();
  //     // const data = extractUniqueDatesAndPrices(response);
  //     // setPriceTrendData(data);
  //   }, []);

  //   useEffect(() => {
  //     //   dispatch(fetchChartsData());
  //       // dispatch(fetchRateClasses());
  //   }, [dispatch]);

  const dealDetails = pricingDetail?.DealDetails || [];
  const summary = pricingDetail || {};

  const formatDate = (iso) => {
    if (!iso) return '';
    try {
      const d = new Date(iso);
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const yy = String(d.getFullYear()).slice(-2);
      return `${mm}/${dd}/${yy}`; // MM/DD/YY
    } catch {
      return iso;
    }
  };

  const formatNumber = (n) => {
    if (n === null || n === undefined) return '';
    return n.toLocaleString();
  };

  const formatPrice = (n) => {
    if (n === null || n === undefined) return '';
    return `$${n.toFixed(6)}`;
  };

  // Helper function to render multiple values with tooltip
  const renderMultipleValues = (values, label) => {
    if (!values || (Array.isArray(values) && values.length === 0)) {
      return '-';
    }
    const arrayValues = Array.isArray(values) ? values : [values];
    return <MultipleValuesTooltip values={arrayValues} />;
  };

  // Get booked date for the card - show "Multiple" only when displayed dates differ
  const getBookedDateForCard = () => {
    if (dealDetails.length === 0) return '-';
    const formattedDates = [
      ...new Set(dealDetails.map(d => d.bookedDate).filter(Boolean).map(d => formatDate(d)))
    ].filter(Boolean);
    if (formattedDates.length === 0) return '-';
    return <MultipleValuesTooltip values={formattedDates} />;
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <div
          style={{
            filter: shouldBlurCharts ? "blur(5px)" : "none",
            pointerEvents: shouldBlurCharts ? "none" : "auto",
            transition: "filter 0.2s ease",
          }}
        >
          <Row className="">
            <Col sm="12">
              {/* <PriceTrendChart 
                  categories={pricingTrendData?.categories} 
                  series={pricingTrendData?.series} 
                  title={"Price Trend Chart"}
                  isLoading={pricingTrendData?.isLoading}
              /> */}
              <PriceTrendChartRechart
                title="Price Trend"
                categories={pricingTrendData?.categories}
                series={pricingTrendData?.series}
                rawDates={pricingTrendData?.rawDates}
                isLoading={pricingTrendData?.isLoading}
                onPointClick={handlePointClick}
              />

            </Col>
          </Row>
          <Row className="xjustify-content-center">
            <Col sm="12">
              <PriceTrendMinMaxChartRechart
                title="Price Trend Overview Chart"
                categories={pricingTrendMinMaxData?.categories}
                series={pricingTrendMinMaxData?.series}
                isLoading={pricingTrendMinMaxData?.isLoading}
              />
            </Col>
          </Row>
        </div>
      </div>
      <ConfirmationModal
        dialogClassName="modal-md"
        centered
        size="xl"
        show={showDetailModal}
        onHide={() => setShowDetailModal(false)}
        title="Pricing Detail"
        confirmButtonLabel="Close"
        onConfirm={() => setShowDetailModal(false)}
      >
          {pricingDetailLoading ? (
            <Div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
              <img src={loader} height={'100px'} alt="Loading" />
            </Div>
          ) : dealDetails.length > 0 ? (
            <>
              <Div className="d-flex flex-wrap mb-3 w-100">
                <Div className="p-1 mb-1 border rounded flex-fill me-1">
                  <Div className="text-muted" style={{ fontSize: 11, fontWeight: 600 }}>Number of Deals</Div>
                  <Div className="fw-bold" style={{ fontSize: 14 }}>{summary.numberOfDeals ?? '-'}</Div>
                </Div>
                <Div className="p-1 mb-1 border rounded flex-fill me-1">
                  <Div className="text-muted" style={{ fontSize: 11, fontWeight: 600 }}>Number of Meters</Div>
                  <Div className="fw-bold" style={{ fontSize: 14 }}>{summary.numberOfMeters ?? '-'}</Div>
                </Div>
                <Div className="p-1 mb-1 border rounded flex-fill me-1">
                  <Div className="text-muted" style={{ fontSize: 11, fontWeight: 600 }}>Booked Date</Div>
                  <Div className="fw-bold" style={{ fontSize: 14 }}>{getBookedDateForCard()}</Div>
                </Div>
                <Div className="p-1 mb-1 border rounded flex-fill">
                  <Div className="text-muted" style={{ fontSize: 11, fontWeight: 600 }}>Price</Div>
                  <Div className="fw-bold" style={{ fontSize: 14 }}>{formatPrice(summary.totalPrice)}</Div>
                </Div>
              </Div>
              <div
                className="table-responsive react-table-sticky-header fs-11"
                style={{ maxHeight: '320px', overflowY: 'auto' }}
              >
                <table className="table table-centered react-table" style={{ width: '100%' }}>
                  <thead className="table-light">
                    <tr>
                      <th style={{ padding: '0.5rem 0.3rem', width: '6%', textAlign: 'right' }}>Term</th>
                      <th style={{ padding: '0.5rem 0.3rem', width: '8%', textAlign: 'right' }}>Price</th>
                      <th style={{ padding: '0.5rem 0.3rem', width: '8%', textAlign: 'right' }}>No. of meters</th>
                      <th style={{ padding: '0.5rem 0.3rem', width: '10%', textAlign: 'center' }}>Customer Class</th>
                      <th style={{ padding: '0.5rem 0.3rem', width: '10%', textAlign: 'right' }}>Annual Usage {annualUsageUnit}</th>
                      <th style={{ padding: '0.5rem 0.3rem', width: '10%', textAlign: 'center' }}>Utility</th>
                      <th style={{
                        padding: '0.5rem 0.3rem',
                        width: '15%',
                        textAlign: 'center',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal'
                      }}>Load Zones</th>
                      <th style={{
                        padding: '0.5rem 0.3rem',
                        width: '18%',
                        textAlign: 'center',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal'
                      }}>{rateClassLabel}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dealDetails.map((d, idx) => (
                      <tr key={idx}>
                        <td style={{ padding: '0.5rem 0.3rem', textAlign: 'right' }}>{d.contractPeriod ?? ''}</td>
                        <td style={{ padding: '0.5rem 0.3rem', textAlign: 'right' }}>{formatPrice(d.finalPrice)}</td>
                        <td style={{ padding: '0.5rem 0.3rem', textAlign: 'right' }}>{d.dealAccountsCount ?? ''}</td>
                        <td style={{ padding: '0.5rem 0.3rem', textAlign: 'center' }}>
                          {renderMultipleValues(d.customerClass ? [d.customerClass] : null, 'Customer Class')}
                        </td>
                        <td style={{ padding: '0.5rem 0.3rem', textAlign: 'right' }}>{formatNumber(d.annualUsage)}</td>
                        <td style={{ padding: '0.5rem 0.3rem', textAlign: 'center' }}>
                          {renderMultipleValues(d.lDCNames, 'Utility')}
                        </td>
                        <td style={{
                          padding: '0.5rem 0.3rem',
                          textAlign: 'center',
                          wordBreak: 'break-word',
                          whiteSpace: 'normal',
                          overflowWrap: 'break-word',
                          maxWidth: '150px'
                        }}>
                          {renderMultipleValues(d.loadZones, 'Load Zones')}
                        </td>
                        <td style={{
                          padding: '0.5rem 0.3rem',
                          textAlign: 'center',
                          wordBreak: 'break-word',
                          whiteSpace: 'normal',
                          overflowWrap: 'break-word',
                          maxWidth: '200px'
                        }}>
                          {renderMultipleValues(
                            (selectedMarket?.name === 'ERCOT' && selectedState?.name === 'Texas')
                              ? d.loadProfiles
                              : d.rateClass,
                            rateClassLabel
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <Div className="text-center text-muted py-3">
              No pricing detail available for this point.
            </Div>
          )}
      </ConfirmationModal>
      {/* <Row className="xjustify-content-center">
            <Col sm="12"> 
            <PriceTrendChart 
                categories={forwardCurveData?.categories} 
                series={forwardCurveData?.series} 
                title={"Forward Curve Chart"} 
                isLoading={forwardCurveData?.isLoading}
            />
            </Col>
        </Row>
        <Row className="xjustify-content-center">
            <Col sm="12"> 
            <PriceTrendMinMaxChart 
                categories={forwardCurveMinMaxData?.categories} 
                series={forwardCurveMinMaxData?.series} 
                title={"Forward Curve Overview Chart"}
                isLoading={forwardCurveMinMaxData?.isLoading}
            />
            </Col>
        </Row> */}
    </>
  );
};

export default ChartSection;
